import { CustomPropertiesEnum } from '../appConsts/CustomPropertiesEnum';
import { checkComapnyId } from './LearningSpaceServices/utils/checkComapnyId';

const {
  assetRequiredProperty,
  userRequiredProperty,
  userQuotaValue,
  assetQuotaValue,
  assetNonQuotaValue
} = CustomPropertiesEnum;

const getLicenseTypeValueIds = companyProperties => {
  const licenseProperty = companyProperties.find(prop => prop.name === assetRequiredProperty);

  return {
    proficiencyIds:
      licenseProperty &&
      licenseProperty.values
        .filter(value => assetQuotaValue.includes(value.value))
        .map(item => item.id),
    nonProficiencyIds:
      licenseProperty &&
      licenseProperty.values
        .filter(value => assetNonQuotaValue.includes(value.value))
        .map(item => item.id)
  };
};

const userQuotaCarryingCheck = userProperties => {
  const licenseTypeProp = userProperties.find(
    property => property.customProperty && property.customProperty.name === userRequiredProperty
  );
  if (licenseTypeProp) {
    const licenseType =
      licenseTypeProp.values && licenseTypeProp.values[0] && licenseTypeProp.values[0].value;
    if (userQuotaValue.includes(licenseType)) {
      return true;
    }
  }

  return false;
};

const contentProficiencyCheck = (contentProperties, proficiencyIds, nonProficiencyIds) => {
  return !!contentProperties.filter(
    property =>
      property.values.some(val => proficiencyIds && proficiencyIds.includes(val)) &&
      !property.values.some(val => nonProficiencyIds && nonProficiencyIds.includes(val))
  ).length;
};

const checkForValidLicenseType = contentProperties => {
  const checkForRestrictions = checkComapnyId();
  if (!checkForRestrictions) {
    return true;
  }
  const userProperties = window._currentUserInfo.customProperties;
  const companyRequiredProperties = window._currentCompanyInfo.requiredAssetCustomProperties;

  let { proficiencyIds, nonProficiencyIds } = getLicenseTypeValueIds(companyRequiredProperties);

  if (
    window._currentCompanyInfo.parentCompanyId === '56e6c0675d63551300f1b690' ||
    window._currentCompanyInfo.parentCompanyId === '56bfef41a17441a959d9c8da'
  ) {
    const parentCompanyRequiredProperties =
      window._parentCompanyInfo && window._parentCompanyInfo.requiredAssetCustomProperties;
    if (parentCompanyRequiredProperties && parentCompanyRequiredProperties.length) {
      const values = getLicenseTypeValueIds(parentCompanyRequiredProperties);
      if (values.proficiencyIds) {
        if (proficiencyIds) {
          proficiencyIds.push(...values.proficiencyIds);
        } else {
          proficiencyIds = values.proficiencyIds;
        }
      }
      if (values.nonProficiencyIds) {
        if (nonProficiencyIds) {
          nonProficiencyIds.push(...values.nonProficiencyIds);
        } else {
          nonProficiencyIds = values.nonProficiencyIds;
        }
      }
    }
  }

  const userIsQuotaCarrying = userQuotaCarryingCheck(userProperties);

  const contentIsProficiency = contentProficiencyCheck(
    contentProperties,
    proficiencyIds,
    nonProficiencyIds
  );

  if (contentIsProficiency) {
    if (userIsQuotaCarrying) {
      return true;
    }
    return false;
  }

  return true;
};

export { checkForValidLicenseType };
export default checkForValidLicenseType;
